<template>
  <v-app class="white-background">
    <v-navigation-drawer
      app
      absolute
      height="auto"
      floating
      :value="layout.showDrawer"
    >
      <categories :params="params" :loaders="loaders" :layout="layout"/>
      <filters :params="params" :layout="layout"/>
    </v-navigation-drawer>
    <v-content>
      <v-card flat>
        <products :params="params" :loaders="loaders" :layout="layout"/>
      </v-card>
    </v-content>
  </v-app>
</template>

<script>
  import Categories from './partials/Categories';
  import Filters from './partials/Filters';
  import Products from './partials/Products';

  export default {
    components: { Categories, Filters, Products },
    data() {
      return {
        layout: {
          materialsFromUrl: [],
          categoriesFromUrl: [],
          showDrawer: null,
        },
        params: {
          search: '',
          categories: [],
          brands: [],
          materials: [],
          priceRange: [1, 2000],
          location: {},
          setCategoriesFromUrl: false,
          setMaterialsFromUrl: false,
          userType: $("#searchable-products").data('user') || 'client'
        },
        loaders: {
          loadingProducts: false
        }
      };
    },
  };
</script>

<style lang="scss">
  .v-application {
    font-family: Lato, 'sans-serif' !important;
    background: white !important;
  }

  button:focus {
    outline: none !important;
  }

  .v-application .v-list-item__title a {
    color: inherit;
  }

  .v-navigation-drawer {
    @media (max-width: 992px) {
      padding-right: 50px;
    }
  }

  .container--products .v-navigation-drawer__content {
    .v-card__title .sidebar-headline {
      font-size: 18px !important;
    }
    .v-list-item__title {
      font-size: 13px !important;
    }

    .subtitle {
      font-size: 18px;
    }
    .v-list {
      padding-left: 18px;
    }
  }
</style>